import { render, staticRenderFns } from "./NavHeader.vue?vue&type=template&id=057d1494&scoped=true"
import script from "./NavHeader.vue?vue&type=script&lang=js"
export * from "./NavHeader.vue?vue&type=script&lang=js"
import style0 from "./NavHeader.vue?vue&type=style&index=0&id=057d1494&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057d1494",
  null
  
)

export default component.exports